import { getStateWithOnlyOneLevel } from '../../../utils/StateSelectorHelper';

function getMyFriendsState(state) {
  return getStateWithOnlyOneLevel(state, 'myFriends');
}

export const getSendFriendsRequestMessage = (state) =>
  getMyFriendsState(state).get('sendFriendsRequestMessage');

export const getSendFriendsRequestWaiting = (state) =>
  getMyFriendsState(state).get('sendFriendsRequestWaiting');

export const getSendFriendsRequestSuccess = (state) =>
  getMyFriendsState(state).get('sendFriendsRequestSuccess');

export const getLoadFriendsWaiting = (state) =>
  getMyFriendsState(state).get('loadFriendsWaiting');

export const getFriendsTotalCount = (state) =>
  getMyFriendsState(state).get('totalFriendsCount');

export const getFriends = (state) => getMyFriendsState(state).get('friends');

export const getremoveFriendWaiting = (state) =>
  getMyFriendsState(state).get('removeFriendWaiting');

export const getremoveFriendSuccess = (state) =>
  getMyFriendsState(state).get('removeFriendSuccess');

export const getRemoveFriendMessage = (state) =>
  getMyFriendsState(state).get('removeFriendMessage');

export const getResolveFriendRequestMessage = (state) =>
  getMyFriendsState(state).get('resolveFriendRequestMessage');

export const getResolveFriendRequesSuccess = (state) =>
  getMyFriendsState(state).get('resolveFriendRequestSuccess');

export const getResolveFriendRequesWaiting = (state) =>
  getMyFriendsState(state).get('resolveFriendRequestWaiting');

export const getFriendRequestNotifications = (state) =>
  getMyFriendsState(state).get('friendRequestNotifications') || [];
